import { useApi } from '../api/api.context';
import { useQueries, useQuery } from 'react-query';
import { QueryKeys } from './query-keys.constants';
import { CheckMyPermissionDto } from '@groundfloor-platform/mgmt-service-g-sdk';

export const useQueryWhoAmI = () => {
  const api = useApi();

  return useQuery(
    QueryKeys.WHOAMI,
    async () => {
      return await api.directoryController.whoami();
    },
    {
      enabled: !!api,
      // Every PermissionBoundary observes this; without a stale time each one refetches on mount.
      staleTime: 60 * 60 * 1000, // 1 hour
      // Otherwise observers mounting on the error screen refetch it in a loop.
      retryOnMount: false
    }
  );
};

export const useQueryCheckMyPermissions = (checks: CheckMyPermissionDto[]) => {
  const api = useApi();

  return useQueries(
    checks.map((check) => ({
      queryKey: [QueryKeys.CHECKMYPERMISSION, check],
      queryFn: async () => await api.directoryController.checkMyPermission(check),
      enabled: !!api
    }))
  );
};
